var map = {
	"./404.svg": 950,
	"./Categories.png": 951,
	"./Edit-menu.svg": 952,
	"./Egg.svg": 953,
	"./Emaier-Header.png": 954,
	"./Qr-4.png": 955,
	"./_duplicate.svg": 956,
	"./_overview.svg": 957,
	"./add-white.svg": 958,
	"./alert.svg": 959,
	"./all_category.svg": 960,
	"./archive.svg": 961,
	"./armchair.svg": 962,
	"./arrow-circle-right.svg": 963,
	"./arrow-left-circle.svg": 964,
	"./arrow-right-circle.svg": 965,
	"./arrow-right.svg": 966,
	"./asc-up-white.svg": 967,
	"./asc.png": 968,
	"./asc.svg": 969,
	"./back-arrow.svg": 970,
	"./barcode-icon.svg": 971,
	"./beverages.svg": 972,
	"./blue-edit-pen.svg": 973,
	"./blue-eye.svg": 974,
	"./box-office.svg": 975,
	"./broken-seat.jpg": 976,
	"./calendar_list.svg": 977,
	"./calender.svg": 363,
	"./chevron-down.svg": 978,
	"./chevron-left.svg": 979,
	"./cinema-mamagement-sidebar.svg": 980,
	"./claendar.svg": 312,
	"./clock-1.svg": 981,
	"./clock.svg": 982,
	"./close-button.svg": 715,
	"./close-white.svg": 717,
	"./close-x.svg": 307,
	"./collapse-up.svg": 983,
	"./collapse.svg": 984,
	"./connection-lost.svg": 361,
	"./consumable-raw-material.svg": 985,
	"./copy.svg": 986,
	"./copy_image_icon.png": 987,
	"./delete-red-light.svg": 988,
	"./delete-red.svg": 724,
	"./delete.svg": 698,
	"./deliver-icon.svg": 989,
	"./desc-down-white.svg": 990,
	"./desc.svg": 991,
	"./distributors-sidebar.svg": 992,
	"./download.svg": 993,
	"./dragndrop.svg": 994,
	"./dragndrop2.svg": 995,
	"./duplicate.svg": 996,
	"./duplicateScreen.svg": 997,
	"./e-wallet-icon-black.svg": 998,
	"./edit-pen-blue.svg": 999,
	"./edit-pen-white.svg": 1000,
	"./edit-pen.svg": 1001,
	"./edit.svg": 1002,
	"./email.png": 1003,
	"./empty-image.svg": 1004,
	"./excel.svg": 1005,
	"./external-link.svg": 1006,
	"./eye.svg": 1007,
	"./filter-icon.svg": 1008,
	"./flag.svg": 1009,
	"./fnb-app-order.svg": 1010,
	"./fnb-beverages.svg": 1011,
	"./fnb-brownie.svg": 1012,
	"./fnb-combo.svg": 1013,
	"./fnb-desert.svg": 1014,
	"./fnb-eatables.svg": 1015,
	"./fnb-make-your-combo.svg": 1016,
	"./fnb-popcorn.svg": 1017,
	"./fnbtransactionIcon.svg": 1018,
	"./fullscreen-icon.svg": 725,
	"./funnel.svg": 1019,
	"./globe.svg": 1020,
	"./green-tick.svg": 1021,
	"./grid-view.svg": 1022,
	"./hide-password.svg": 364,
	"./home-icon.svg": 1023,
	"./home.svg": 1024,
	"./icon-black-play.svg": 1025,
	"./icon-dot.svg": 1026,
	"./icon-fnb.svg": 1027,
	"./icon-marketing.svg": 1028,
	"./icon-no-seat.png": 1029,
	"./icon-no-seat.svg": 1030,
	"./icon-option.svg": 1031,
	"./icon-poin-of-sale.svg": 1032,
	"./icon-recliner.svg": 1033,
	"./icon-report.svg": 1034,
	"./icon-sofa-dark-1.svg": 1035,
	"./icon-sofa-dark.png": 1036,
	"./icon-sofa-dark.svg": 1037,
	"./icon-sofa.svg": 1038,
	"./importfile.svg": 1039,
	"./info.svg": 718,
	"./info2.svg": 1040,
	"./keyboard-icon.svg": 1041,
	"./kitchen_display.svg": 1042,
	"./language-icon.svg": 365,
	"./left-caret.svg": 1043,
	"./link.svg": 1044,
	"./list-view.svg": 1045,
	"./loading.svg": 366,
	"./lock.svg": 1046,
	"./login-password.png": 367,
	"./login-user.png": 368,
	"./logout.svg": 719,
	"./masters-sidebar.svg": 1047,
	"./merchandise.svg": 1048,
	"./minus.svg": 1049,
	"./movie-pass-svg.svg": 707,
	"./movie-rolling.svg": 1050,
	"./mulitSchedule.svg": 1051,
	"./multicurrency.svg": 1052,
	"./multifnb.svg": 1053,
	"./nav-plus.svg": 1054,
	"./new_filter_icon.svg": 1055,
	"./no-image.svg": 1056,
	"./no-schedule.svg": 143,
	"./non-veg-mark.png": 1057,
	"./non-veg-mark.svg": 1058,
	"./notification.svg": 1059,
	"./open-link-blue.svg": 1060,
	"./openPlanned.svg": 1061,
	"./overview.svg": 1062,
	"./overview2.svg": 1063,
	"./pdf-icon.svg": 1064,
	"./pdf.svg": 1065,
	"./pickup-ticket-icon.svg": 1066,
	"./pickupfnb.svg": 1067,
	"./play.svg": 1068,
	"./plus.svg": 1069,
	"./pointofsale-1.svg": 1070,
	"./pointofsale-2.svg": 1071,
	"./pointofsale.png": 1072,
	"./portfolio.svg": 1073,
	"./pos-fnb-no-itmes.svg": 711,
	"./pos-refresh.svg": 1074,
	"./primary/chevron-down.svg": 1075,
	"./primary/download.svg": 1076,
	"./primary/edit.svg": 1077,
	"./primary/filter.svg": 1078,
	"./primary/printer.svg": 1079,
	"./print-icon.svg": 1080,
	"./print.svg": 1081,
	"./question.svg": 1082,
	"./question1.svg": 1083,
	"./question2.svg": 726,
	"./question3.svg": 1084,
	"./recliner-1.svg": 1085,
	"./recliner.png": 1086,
	"./refund-icon.svg": 1087,
	"./reload-icon-pos.svg": 1088,
	"./reload-icon.svg": 1089,
	"./restore.svg": 1090,
	"./right-caret.svg": 1091,
	"./role-management-sidebar.svg": 1092,
	"./save.svg": 1093,
	"./schedule-icon.svg": 1094,
	"./school-calendar.svg": 1095,
	"./search-global-white.svg": 1096,
	"./search-global.svg": 1097,
	"./search.svg": 1098,
	"./searchIcon.svg": 1099,
	"./seat-icon-2.svg": 1100,
	"./seat-icon.svg": 1101,
	"./seat-icons/3-wheelChair.png": 1102,
	"./seat-icons/block_seat_new.png": 1103,
	"./seat-icons/broken-seat-1.svg": 1104,
	"./seat-icons/broken-seat-2.svg": 1105,
	"./select-food.png": 727,
	"./settings.svg": 1106,
	"./show-password.svg": 369,
	"./slider-triangle.svg": 720,
	"./snack.svg": 721,
	"./sort.svg": 1107,
	"./star-empty.svg": 1108,
	"./star-fill.svg": 1109,
	"./success-tick.svg": 1110,
	"./suitcase.svg": 1111,
	"./swap.svg": 1112,
	"./tick-green-item.svg": 728,
	"./tick-green.svg": 1113,
	"./ticket-icon.svg": 1114,
	"./trash.svg": 1115,
	"./unpaid-reservation.svg": 703,
	"./updown-white.svg": 1116,
	"./updown.svg": 1117,
	"./user-attribute.svg": 1118,
	"./user-attributes.svg": 1119,
	"./user-female.svg": 1120,
	"./user-male-white.svg": 1121,
	"./user-male.svg": 1122,
	"./user-profile.svg": 1123,
	"./userProfile.png": 1124,
	"./veg-food-mark-white.png": 1125,
	"./veg-foog-mark-trans.png": 1126,
	"./view.png": 1127,
	"./view.svg": 1128
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 949;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons ^\.\/.*$
// module id = 949
// module chunks = 37